










































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import UserModule from '@/store/modules/user';

@Component({})
export default class UserInfo extends Vue {
  @PropSync('userCount', {}) userCountSync!: [];

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin') {
      return UserModule.currentRole;
    }
    return null;
  }
}

